import { SET_EMPLOYEES_WORKOUT_WATCHTIME, SET_NUMBER_OF_EMPLOYEES, SET_TEAM_FAVORITE_WORKOUT } from "./types";
import { apiCallV2 } from "../../../utils/api";

export const GetCompanyEmployeesWorkoutWatchtime = (filter = null) => async (dispatch, getState) => {


   const res = await apiCallV2(
      "GET",
      "get-company-employees-workout-watchtime",
      "",
      localStorage.getItem("access-token"),
      filter
   );

   if (res.status === 200) {
      dispatch({
         type: SET_EMPLOYEES_WORKOUT_WATCHTIME,
         data: [...res.data.data.workouts]
      })
   }

}

export const GetNumberOfEmployees = (filter = null) => async (dispatch, getState) => {

   const res = await apiCallV2(
      "GET",
      "get-number-of-employees",
      "",
      localStorage.getItem("access-token"),
      filter
   );

   if (res.status === 200) {
      dispatch({
         type: SET_NUMBER_OF_EMPLOYEES,
         data: res.data.data.numberOfEmployees
      })
   }

}

export const GetTeamFavoriteWorkouts = (filter = null) => async (dispatch, getState) => {

   const res = await apiCallV2(
      "GET",
      "get-team-favorite-workouts",
      "",
      localStorage.getItem("access-token"),
      filter
   );

   if (res.status === 200) {
      dispatch({
         type: SET_TEAM_FAVORITE_WORKOUT,
         data: res.data.data.workouts
      })
   }

}

export const GetCompanyProfile = (token) => async (dispatch, getState) => {
   const res = await apiCallV2(
      "GET",
      "get-company-porfile",
      "",
      "",
      {
         token: token,
      }
   );
   if (res.status === 200) {
      return res.data.data[0];
   } else {
      return null;
   }

}